import { InputNumberProps } from 'antd/lib/input-number'
import { percent } from '@/utils/form'
import InputNumber from './InputNumber'

const PercentInput = ({ ...props }: InputNumberProps) => (
  <InputNumber {...props} {...percent} />
)

export default PercentInput
